<template>
  <a-checkbox-group :value="field.value" button-style="solid" @change="handleChangeInternal">
    <a-button-group>
      <a-tooltip :title="t('propsEditor.fontBold')">
        <a-button>
          <a-checkbox value="bold">
            <BoldOutlined />
          </a-checkbox>
        </a-button>
      </a-tooltip>
      <a-tooltip :title="t('propsEditor.fontItalic')">
        <a-button>
          <a-checkbox value="italic">
            <ItalicOutlined />
          </a-checkbox>
        </a-button>
      </a-tooltip>
    </a-button-group>
  </a-checkbox-group>
</template>
<script>
import { props } from './helper';
import { defineComponent } from 'vue';
import { BoldOutlined, ItalicOutlined } from '@ant-design/icons-vue';
import i18n from '@/locales/i18n';

const { t } = i18n.global;
export default defineComponent({
  components: { BoldOutlined, ItalicOutlined },
  props,
  setup(props) {
    const handleChangeInternal = v => {
      const { value = [] } = props.field;
      const result = [...value];
      if (v.indexOf('bold') === -1) {
        result[0] = value[0] === -1 ? -1 : '';
      } else {
        result[0] = 'bold';
      }

      if (v.indexOf('italic') === -1) {
        result[1] = value[1] === -1 ? -1 : '';
      } else {
        result[1] = 'italic';
      }
      // console.log('22222222222222', v, value, result);
      props.handleChange(result);
    };
    return { t, handleChangeInternal };
  },
});
</script>
<style lang="less" scoped>
.ant-checkbox-wrapper {
  display: flex;
  height: 100%;
  padding: 0 5px;
  align-items: center;
  ::v-deep(.ant-checkbox) {
    display: none;
  }
}

.ant-btn {
  padding: 0;
}
.ant-checkbox-wrapper-checked {
  color: #fff;
  background: @primary-color;
}
</style>
